import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface ErrorResponse {
  status: string;
  statusText?: string;
  message?: string;
}

@Injectable()
export class ErrorService {

  errors: ErrorResponse[];

  constructor(
    private router: Router,
  ) {
    this.errors = [];
  }

  handleErrorResponse(res) {
    this.errors.push(res);
    this.router.navigate(['error']);
  }
}



// WEBPACK FOOTER //
// ./src/services/error.service.ts